import React from 'react';
import useBundleTranslation from 'i18n';
import { Popup } from 'components/common/popup/Popup';
import { Box } from '@mui/material';
import { customRequestAPI } from 'api/api';

interface WarnMismatchLoginPopupProps {
    onHide: () => void;
    userName: string;
}
export function WarnMismatchLoginPopup(props: WarnMismatchLoginPopupProps) {
    const { t } = useBundleTranslation(['components/common/warn_mismatch_login_popup']);

    return (
        <Popup
            maxWidth={'popupMd'}
            open={true}
            settings={{
                textOK: t('btn_ok'),
                noCancel: true,
            }}
            onHide={null}
            onConfirm={() => {
                customRequestAPI
                    .post('/auth/update-username', {})
                    .then((response: any) => {})
                    .catch(() => {});
                props.onHide();
            }}
        >
            <Box>{t('message', { usernameLoggedInSamlAsMi: props.userName })}</Box>
        </Popup>
    );
}
